export default __webpack_public_path__ + "static/media/womanThinking.63f4a434.svg";